import f3tch from 'f3tch';

import API_URL from '../../constants/url.constant.api';
import profile from '../../profiles/json.profile.api';

const inquiryApi = (inquiry) =>
  f3tch('/order/inquiry')
    .profile(profile({url: API_URL()}))
    .body(inquiry)
    .post();

export default inquiryApi;
